import { render, staticRenderFns } from "./contractMinorPopup.vue?vue&type=template&id=1abd67ae&scoped=true"
import script from "./contractMinorPopup.vue?vue&type=script&lang=js"
export * from "./contractMinorPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abd67ae",
  null
  
)

export default component.exports